// extracted by mini-css-extract-plugin
module.exports = {"promptButton":"webNotificationsSettings_promptButton__3DNbR","WebNotificationsText":"webNotificationsSettings_WebNotificationsText__1aE1K"};